export default __webpack_public_path__ + "static/media/micro-plus.ceaa757d.svg";